import { render, staticRenderFns } from "./SendUpdate.vue?vue&type=template&id=3231a5f5"
import script from "./SendUpdate.vue?vue&type=script&lang=js"
export * from "./SendUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports